module.exports = __webpack_public_path__ + "img/car.f2f2de6b.svg";